import {tradePair$} from '@/state/trade-pair';
import {toWsMsg$} from '@/ws';
import {toUiMsg$} from '@/ui';
import {trades$} from './trades';
import type {TradeData, TradePair} from '@/types';

export interface UTrades {
  type: 'trades';
  data: TradeData;
}

export function subscribeTrade() {
  tradePair$.subscribe((tradePair: TradePair) => {
    const {type, symbol} = tradePair;
    const subMethod = type === 'PerpetualV2' ? 'trade_p.subscribe' : 'trade.subscribe';
    const unSubMethod = type === 'PerpetualV2' ? 'trade_p.unsubscribe' : 'trade.unsubscribe';
    toWsMsg$.next({method: unSubMethod, params: []});
    toWsMsg$.next({method: subMethod, params: [symbol]});
  });
  trades$.subscribe((data) => toUiMsg$.next({type: 'trades', data}));
}
